module.exports = __webpack_public_path__ + "08_bob_black.5bef5786.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_bob_black.png
// module id = eMuh
// module chunks = 0